<div class="row">
    <div class="col-md-4">
      <div class="mcd-filter-tag-wrapper">
        <div class="mcd-tag-title">Filter By Standard Type</div>
        <mat-checkbox *ngFor="let item of standardTypes" [checked]="setCheckedStateForCheckBoxes(3, item.id)"
          (change)="addFilter($event, item.id, 3)">{{item.name}}</mat-checkbox>
      </div>
    </div>
  </div>